import src from "IMAGE";
export default { src, width: 1920, height: 576, blurWidth: 0, blurHeight: 0};
